import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sendFormPQRS } from "../conexion/vehicles.conexion";
import { buildCmsUrl } from "../../utils/imageHelper";

/*eslint-disable */
declare const window: any;

interface propsI {
  handleOpenModal: any;
}

const ContenidoComponent: React.FC<propsI> = ({ handleOpenModal }) => {
  const [nombre, setNombre]: any = useState("");
  const [apellido, setApellido] = useState("");
  const [correo, setCorreo] = useState("");
  const [celular, setCelular] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");
  const [tipoConsulta, setTipoConsulta] = useState("");
  const [tipoSolicitud, setTipoSolicitud] = useState("");
  const [concesionario, setConcesionario] = useState("");
  const [concesionarios, setConcesionarios] = useState([]);
  const [sede, setSede] = useState("");
  const [modelo, setModelo] = useState("");
  const [concesionariosData, setConcesionariosData] = useState<any[]>([]);
  const [modelos, setModelos] = useState([
    {
      nombremodelo: "IONIQ 5 EV",
      nombrefamilia: "IONIQ 5",
      internal: "IONIQ 5",
      idmodelo: "a1YQC000000FK4s2AG",
      idfamilia: "a1FQC000007vHGE2A2",
    },
    {
      nombremodelo: "TUCSON 2.0L",
      nombrefamilia: "TUCSON GASOLINA",
      internal: "TUCSON Gasolina",
      idmodelo: "a1YQC000000FL4A2AW",
      idfamilia: "a1FQC000007vHWM2A2",
    },
    {
      nombremodelo: "TUCSON 1.6T HEV",
      nombrefamilia: "TUCSON HIBRIDA",
      internal: "TUCSON Híbrida",
      idmodelo: "a1YQC000001AXN72AO",
      idfamilia: "a1FQC00000U0pFl2AJ",
    },
    {
      nombremodelo: "GRAND I10 1.2L",
      nombrefamilia: "Grand i10",
      internal: "GRAND METRO SEDÁN",
      idmodelo: "a1YQC000000FKT42AO",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10",
      nombrefamilia: "Grand i10",
      internal: "Grand i10",
      idmodelo: "a1YQC000003IjZd2AK",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "GRAND I10 HB 1.2L",
      nombrefamilia: "Grand i10",
      internal: "GRAND METRO HATCHBACK",
      idmodelo: "a1YQC0000010Fhd2AE",
      idfamilia: "a1FQC000007vHco2AE",
    },
    {
      nombremodelo: "CRETA 1.5L",
      nombrefamilia: "CRETA",
      internal: "CRETA",
      idmodelo: "a1YQC000000FLTx2AO",
      idfamilia: "a1FQC000007vHuX2AU",
    },
    {
      nombremodelo: "HB20 1.6L",
      nombrefamilia: "HB20",
      internal: "HB20 Hatchback",
      idmodelo: "a1YQC000000FKrG2AW",
      idfamilia: "a1FQC000007vI7R2AU",
    },
    {
      nombremodelo: "HB20S 1.6L",
      nombrefamilia: "HB20S",
      internal: "HB20S Sedán",
      idmodelo: "a1YQC000000FLIf2AO",
      idfamilia: "a1FQC000007vI932AE",
    },
    {
      nombremodelo: "KONA 2.0L",
      nombrefamilia: "KONA",
      internal: "KONA Gasolina",
      idmodelo: "a1YQC000000FLtl2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida",
      idmodelo: "a1YQC000000FLvN2AW",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA EV",
      nombrefamilia: "KONA",
      internal: "KONA Eléctrica",
      idmodelo: "a1YQC000000FM6f2AG",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "KONA 1.6L HEV",
      nombrefamilia: "KONA",
      internal: "KONA Híbrida N Line",
      idmodelo: "a1YQC000000eQyH2AU",
      idfamilia: "a1FQC000007vIAf2AM",
    },
    {
      nombremodelo: "PALISADE 3.5L",
      nombrefamilia: "PALISADE",
      internal: "PALISADE",
      idmodelo: "a1YQC000000FM9t2AG",
      idfamilia: "a1FQC000007vIH72AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA panel",
      idmodelo: "a1YQC000000FK9i2AG",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 3.5L",
      nombrefamilia: "STARIA",
      internal: "STARIA lujo",
      idmodelo: "a1YQC000000FMD72AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "STARIA 2.2L DIESEL",
      nombrefamilia: "STARIA",
      internal: "STARIA pasajeros",
      idmodelo: "a1YQC000000FMEj2AO",
      idfamilia: "a1FQC000007vIIj2AM",
    },
    {
      nombremodelo: "VENUE 1.6L",
      nombrefamilia: "VENUE",
      internal: "VENUE",
      idmodelo: "a1YQC000000FMhl2AG",
      idfamilia: "a1FQC000007vILx2AM",
    },
    {
      nombremodelo: "SANTA FE 1.6T HEV",
      nombrefamilia: "SANTA FE Híbrida",
      internal: "SANTA FE Híbrida",
      idmodelo: "a1YQC0000011VPN2A2",
      idfamilia: "a1FQC00000PcdoL2AR",
    },
  ]);
  const [placa, setPlaca] = useState("");
  const [vin, setVin] = useState("");
  const [kilometraje, setKilometraje]: any = useState("");
  const [mensaje, setMensaje] = useState("");
  const [politica1, setPolitica1] = useState(false);
  const [politica2, setPolitica2] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [error, setError]: any = useState({});

  useEffect(() => {
    const fetchConcesionariosData = async () => {
      try {
        const response = await fetch(
          buildCmsUrl("api/concessionaire-cols?populate[concessionaires][populate][headquarters][populate][doty][populate]=*"),
        );
        const json = await response.json();

        const transformedData = json.data.flatMap((region: any) =>
          region.concessionaires.flatMap((cons: any) =>
            cons.headquarters.map((hq: any) => ({
              CONCESIONARIO: cons.concessionaire || "",
              webform_name: hq.webform_name || "",
              DEPARTAMENTO: region.department || "",
              CIUDAD: region.city || "",
              "VITRINA (EXPOSICIÓN)": hq.headquarter || "",
              COD_VITRINA_EXPOSICION: hq.headquarters_cod || "",
              NIT: hq.nit || "",
              "ID Dealers": hq.dealer_id || "",
              "ID sucursales": hq.branch_id || "",
              "TIPO DE VEHICULOS": hq.vehicle_type || "",
              Department_Code_And_Name: region.region || "",
              City: region.municipality || "",
            })),
          ),
        );

        setConcesionariosData(transformedData);
        /* console.log("✅ Concesionarios cargados:", transformedData.length); */

      } catch (error) {
        console.error("Error al obtener concesionarios:", error);
      }
    };

    fetchConcesionariosData();
  }, []);

  const isValid = () => {
    return (
      validarTexto(nombre, 2, 50) &&
      validarTexto(apellido, 2, 50) &&
      validarCorreo(correo) &&
      validarCelular(celular) &&
      validarTexto(ciudad, 2, 50) &&
      validarTexto(tipoDocumento, 2, 30) &&
      validarNumero(numeroDocumento, 5, 20) &&
      validarTexto(tipoConsulta, 2, 50) &&
      validarTexto(tipoSolicitud, 2, 50) &&
      validarTexto(concesionario, 2, 50) &&
      validarTexto(modelo, 1, 50) &&
      validarTexto(placa, 5, 10) &&
      validarTexto(vin, 17, 17) &&
      validarKilometraje(kilometraje) &&
      politica1 &&
      politica2
    );
  };

  const validarCampos = () => {
    const errores: any = {};

    if (!validarTexto(nombre, 2, 50))
      errores.nombre = "Nombre inválido (2-50 caracteres)";
    if (!validarTexto(apellido, 2, 50))
      errores.apellido = "Apellido inválido (2-50 caracteres)";
    if (!validarCorreo(correo)) errores.correo = "Correo inválido";
    if (!validarCelular(celular))
      errores.celular = "Número de celular inválido";
    if (!validarTexto(ciudad, 2, 50))
      errores.ciudad = "Ciudad inválida (2-50 caracteres)";
    if (!validarTexto(tipoDocumento, 2, 30))
      errores.tipoDocumento = "Tipo de documento inválido";
    if (!validarNumero(numeroDocumento, 5, 20))
      errores.numeroDocumento = "Número de documento inválido";
    if (!validarTexto(tipoConsulta, 2, 50))
      errores.tipoConsulta = "Tipo de consulta inválido";
    if (!validarTexto(tipoSolicitud, 2, 50))
      errores.tipoSolicitud = "Tipo de solicitud inválida";
    if (!validarTexto(concesionario, 2, 50))
      errores.concesionario = "Concesionario inválido";
    if (!validarTexto(modelo, 1, 50)) errores.modelo = "Modelo inválido";
    if (!validarTexto(placa, 5, 10))
      errores.placa = "Placa inválida (5-10 caracteres)";
    if (!validarTexto(vin, 17, 17))
      errores.vin = "VIN inválido (Debe tener 17 caracteres)";
    if (!validarKilometraje(kilometraje))
      errores.kilometraje = "Kilometraje inválido (1-1,000,000 km)";
    if (!politica1) errores.politica1 = "Debes aceptar la política de datos";
    if (!politica2)
      errores.politica2 = "Debes autorizar la transferencia de datos";

    setError(errores);
    return Object.keys(errores).length === 0;
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value, type } = e.target;
    const fieldValue = value;

    setError((prevErrores: any) => {
      const nuevosErrores = { ...prevErrores };

      if (name === "nombre")
        nuevosErrores.nombre = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Nombre inválido (2-50 caracteres)";
      if (name === "apellido")
        nuevosErrores.apellido = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Apellido inválido (2-50 caracteres)";
      if (name === "correo")
        nuevosErrores.correo = validarCorreo(fieldValue as string)
          ? ""
          : "Correo inválido";
      if (name === "celular")
        nuevosErrores.celular = validarCelular(fieldValue as string)
          ? ""
          : "Número de celular inválido";
      if (name === "ciudad")
        nuevosErrores.ciudad = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Ciudad inválida (2-50 caracteres)";
      if (name === "tipoDocumento")
        nuevosErrores.tipoDocumento = validarTexto(fieldValue as string, 2, 30)
          ? ""
          : "Tipo de documento inválido";
      if (name === "numeroDocumento")
        nuevosErrores.numeroDocumento = validarNumero(fieldValue, 5, 20)
          ? ""
          : "Número de documento inválido";
      if (name === "tipoConsulta")
        nuevosErrores.tipoConsulta = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Tipo de consulta inválido";
      if (name === "tipoSolicitud")
        nuevosErrores.tipoSolicitud = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Tipo de solicitud inválida";
      if (name === "concesionario")
        nuevosErrores.concesionario = validarTexto(fieldValue as string, 2, 50)
          ? ""
          : "Concesionario inválido";
      if (name === "modelo")
        nuevosErrores.modelo = validarTexto(fieldValue as string, 1, 50)
          ? ""
          : "Modelo inválido";
      if (name === "placa")
        nuevosErrores.placa = validarTexto(fieldValue as string, 5, 10)
          ? ""
          : "Placa inválida (5-10 caracteres)";
      if (name === "vin")
        nuevosErrores.vin = validarTexto(fieldValue as string, 17, 17)
          ? ""
          : "VIN inválido (Debe tener 17 caracteres)";
      if (name === "kilometraje")
        nuevosErrores.kilometraje = validarKilometraje(Number(fieldValue))
          ? ""
          : "Kilometraje inválido (1-1,000,000 km)";

      return nuevosErrores;
    });
  };

  const validarTexto = (valor: string, min: number, max: number) => {
    return (
      typeof valor === "string" &&
      valor.trim().length >= min &&
      valor.trim().length <= max
    );
  };

  const validarNumero = (valor: string | number, min: number, max: number) => {
    const num = Number(valor);
    return (
      !isNaN(num) &&
      num.toString().length >= min &&
      num.toString().length <= max
    );
  };

  const validarCorreo = (correo: string) => {
    const regexCorreo = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    return regexCorreo.test(correo);
  };

  const validarCelular = (celular: string) => {
    const regexCelular = /^\+?\d{7,15}$/;
    return regexCelular.test(celular);
  };

  const validarKilometraje = (kilometraje: number) => {
    return !isNaN(kilometraje) && kilometraje > 0 && kilometraje <= 1000000;
  };

  const handleSubmit = async () => {
    setIsLogin(true);
    if (validarCampos() && !isLogin) {
      try {
        const concesionarioSeleccionado = concesionariosData.find(
          (e: any) => e.NIT === concesionario,
        );

        const ciudadSeleccionada = concesionariosData.find(
          (e: any) => e.CIUDAD?.toUpperCase() === ciudad?.toUpperCase(),
        );

        const sede = concesionarioSeleccionado?.COD_VITRINA_EXPOSICION || "";
        const provincia = `${ciudadSeleccionada?.DEPARTAMENTO || ""}|${ciudadSeleccionada?.City || ""
          }`;

        const response = await fetch(
          `https://gateway.hyundaicolombia.co/crearCaso`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              nombre: nombre,
              apellido: apellido,
              correo: correo,
              celular: celular,
              cedula: tipoDocumento,
              vehiculo_interes: modelo,
              kilometraje: kilometraje,
              placa: placa,
              vin: vin,
              mensaje: mensaje,
              legalComunicaciones: "1",
              subject: tipoSolicitud,
              tipo_consulta: tipoConsulta,
              tipo_documento: numeroDocumento,
              concesionario: concesionario,
              sede: sede,
              provincia: provincia,
            }),
          },
        );
        const data = await response.json();

        sendFormPQRS({
          data: {
            user_name: nombre,
            user_lastname: apellido,
            user_email: correo,
            user_phone: celular,
            user_cc: tipoDocumento,
            vehicle: modelo,
            vehicle_kilometers: kilometraje,
            vehicle_plate: placa,
            vin: vin,
            message: mensaje,
            comm_legals: "1",
            subject: tipoSolicitud,
            pqr_type: tipoConsulta,
            user_cc_type: numeroDocumento,
            concessionaire: concesionario,
            branch_office: sede,
            provincia: provincia,
          },
        }).then(function (res: any) {
          setNombre("");
          setApellido("");
          setCorreo("");
          setCelular("");
          setCiudad("");
          setTipoDocumento("");
          setNumeroDocumento("");
          setTipoConsulta("");
          setTipoSolicitud("");
          setConcesionario("");
          setSede("");
          setModelo("");
          setPlaca("");
          setVin("");
          setKilometraje("");
          setMensaje("");
          setPolitica1(false);
          setPolitica2(false);
          handleOpenModal();
          setIsLogin(false);
        });
      } catch (error) {
        console.error("Error fetching concesionarios: ", error);
      }
    }
  };

  const fetchConcesionarios = async (ciudad: string) => {
    try {
      const filtered: any = concesionariosData
        ?.filter((e: any) => e.CIUDAD?.toUpperCase() === ciudad?.toUpperCase())
        .reduce((acc: any[], curr: any) => {
          if (!acc.some((c) => c.NIT === curr.NIT)) acc.push(curr);
          return acc;
        }, []);

      setConcesionarios(filtered);
    } catch (error) {
      console.error("Error filtrando concesionarios:", error);
    }
  };

  return (
    <div className="pqr-container-component">
      <div className="left">
        {/* H2 - Título del formulario */}
        <h2 className="title">Envíanos un mensaje</h2>

        <div className="form row">
          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Nombre</label>
              <input
                type="text"
                name="nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                onBlur={handleBlur}
              />
              {error.nombre && <span className="error">{error.nombre}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Apellido</label>
              <input
                type="text"
                name="apellido"
                value={apellido}
                onChange={(e) => setApellido(e.target.value)}
                onBlur={handleBlur}
              />
              {error.apellido && (
                <span className="error">{error.apellido}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label>Correo</label>
              <input
                type="email"
                name="correo"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                onBlur={handleBlur}
              />
              {error.correo && <span className="error">{error.correo}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Celular</label>
              <input
                type="tel"
                name="celular"
                value={celular}
                onChange={(e) => setCelular(e.target.value)}
                onBlur={handleBlur}
              />
              {error.celular && <span className="error">{error.celular}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Ciudad</label>
              <select
                name="ciudad"
                value={ciudad}
                onChange={(e) => {
                  const value = e.target.value;
                  setCiudad(value);
                  fetchConcesionarios(value);
                }}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {Array.from(
                  new Set(
                    concesionariosData
                      ?.map((item: any) => item.CIUDAD)
                      .filter((c: string | null) => c && c.trim() !== ""),
                  ),
                )
                  .sort((a, b) =>
                    a.localeCompare(b, "es", { sensitivity: "base" }),
                  )
                  .map((ciudad: string) => (
                    <option key={ciudad} value={ciudad}>
                      {ciudad}
                    </option>
                  ))}
              </select>

              {error.ciudad && <span className="error">{error.ciudad}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="">Tipo de documento</label>
              <select
                name="tipoDocumento"
                value={tipoDocumento}
                onChange={(e) => setTipoDocumento(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">-Tipo de documento-</option>
                <option value="nid">Cédula de ciudadanía</option>
                <option value="foreigner_id">Cédula Extranjería</option>
                <option value="passport">Pasaporte</option>
                <option value="CIF">NIF</option>
              </select>
              {error.tipoDocumento && (
                <span className="error">{error.tipoDocumento}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="numeroDocumento">Número de documento</label>
              <input
                type="text"
                name="numeroDocumento"
                value={numeroDocumento}
                onChange={(e) => setNumeroDocumento(e.target.value)}
                onBlur={handleBlur}
              />
              {error.numeroDocumento && (
                <span className="error">{error.numeroDocumento}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="tipoConsulta">Tipo de consulta</label>
              <select
                name="tipoConsulta"
                value={tipoConsulta}
                onChange={(e) => setTipoConsulta(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">-Tipo de consulta-</option>
                <option value="Marketing">Marketing</option>
                <option value="Ventas">Ventas</option>
                <option value="Postventa">Postventa</option>
              </select>
              {error.tipoConsulta && (
                <span className="error">{error.tipoConsulta}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="tipoSolicitud">Tipo de solicitud</label>
              <select
                name="tipoSolicitud"
                value={tipoSolicitud}
                onChange={(e) => setTipoSolicitud(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Seleccionar</option>
                {tipoConsulta === "Marketing" && (
                  <>
                    <option value="Consulta - Solicitud de información Marketing">
                      Consulta - Solicitud de información Marketing
                    </option>
                    <option value="Reclamación Marketing">
                      Reclamación Marketing
                    </option>
                    <option value="Llamada de Cortesía">
                      Llamada de Cortesía
                    </option>
                  </>
                )}

                {tipoConsulta === "Ventas" && (
                  <>
                    <option value="Consulta - Solicitud información de ventas">
                      Consulta - Solicitud información de ventas
                    </option>
                    <option value="Oferta comercial Vehículos">
                      Oferta comercial Vehículos
                    </option>
                    <option value="Reclamación de Ventas">
                      Reclamación de Ventas
                    </option>
                  </>
                )}

                {tipoConsulta === "Postventa" && (
                  <>
                    <option value="Reclamación Postventa">
                      Reclamación Postventa
                    </option>
                    <option value="Consulta - Solicitud de información Postventa">
                      Consulta - Solicitud de información Postventa
                    </option>
                    <option value="Reclamación APP">Reclamación APP</option>
                    <option value="Consulta - Solicitud información APP">
                      Consulta - Solicitud información APP
                    </option>
                    <option value="Reclamación de sistemas">
                      Reclamación de sistemas
                    </option>
                    <option value="Consulta - Solicitud de información de sistemas">
                      Consulta - Solicitud de información de sistemas
                    </option>
                    <option value="Oportunidad Comercial (Lead)">
                      Oportunidad Comercial (Lead)
                    </option>
                    <option value="Llamada de Cortesía">
                      Llamada de Cortesía
                    </option>
                  </>
                )}
              </select>

              {error.tipoSolicitud && (
                <span className="error">{error.tipoSolicitud}</span>
              )}
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-6">
            {/* H3 - Subtítulo de sección */}
            <h3 className="subTitle">
              Soy propietario de un Hyundai (Opcional)
            </h3>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="concesionario">Concesionario</label>
              <select
                name="concesionario"
                value={concesionario}
                onChange={(e) => setConcesionario(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {concesionarios?.map((concesionario: any) => (
                  <option key={concesionario.NIT} value={concesionario.NIT}>
                    {concesionario.CONCESIONARIO}
                  </option>
                ))}
              </select>
              {error.concesionario && (
                <span className="error">{error.concesionario}</span>
              )}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="modelo">Modelo</label>
              <select
                name="modelo"
                value={modelo}
                onChange={(e) => setModelo(e.target.value)}
                onBlur={handleBlur}
              >
                <option value="">Selecciona</option>
                {modelos?.map((model: any) => (
                  <option key={model.idmodelo} value={model.nombremodelo}>
                    {model.nombremodelo}
                  </option>
                ))}

              </select>
              {error.modelo && <span className="error">{error.modelo}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="placa">Placa</label>
              <input
                type="text"
                name="placa"
                value={placa}
                onChange={(e) => setPlaca(e.target.value)}
                onBlur={handleBlur}
              />
              {error.placa && <span className="error">{error.placa}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="vin">VIN</label>
              <input
                type="text"
                name="vin"
                value={vin}
                onChange={(e) => setVin(e.target.value)}
                onBlur={handleBlur}
              />
              {error.vin && <span className="error">{error.vin}</span>}
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="kilometraje">Kilometraje</label>
              <input
                type="text"
                name="kilometraje"
                value={kilometraje}
                onChange={(e) => setKilometraje(e.target.value)}
                onBlur={handleBlur}
              />
              {error.kilometraje && (
                <span className="error">{error.kilometraje}</span>
              )}
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo">
              <label htmlFor="mensaje">Mensaje</label>
              <textarea
                name="mensaje"
                value={mensaje}
                onChange={(e) => setMensaje(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo-check">
              <div>
                <input
                  type="checkbox"
                  name="politica_1"
                  checked={politica1}
                  onChange={(e) => setPolitica1(e.target.checked)}
                />
              </div>
              <label htmlFor="">
                Acepto política de datos, términos y condiciones.
              </label>
            </div>
          </div>

          <div className="col-lg-12 col-sm-12 mb-4">
            <div className="campo-check">
              <div>
                <input
                  type="checkbox"
                  name="politica_2"
                  checked={politica2}
                  onChange={(e) => setPolitica2(e.target.checked)}
                />
              </div>
              <label htmlFor="">
                Autorizo la transferencia y transmisión de mis datos.
              </label>
            </div>
          </div>
        </div>

        <div className="text_legal">
          Estamos comprometidos con tu privacidad, por ello, en Hyundai Colombia
          S.A.S. junto con nuestros aliados oficiales te aseguramos que
          utilizaremos la información que nos proporcionas para comunicarnos
          contigo acerca de nuestros productos, servicios, ofertas,
          invitaciones, encuestas, entre otras finalidades y contenidos
          relevantes para ti. Puedes darte de baja de estas comunicaciones en
          cualquier momento. Para obtener más información consulta nuestra{" "}
          <br></br>
          <a
            href="https://hyundaicolombia.co/politica-proteccion-datos"
            target="_blank"
            rel="noopener noreferrer"
          >
            Politica de privacidad
          </a>{" "}
          <a
            href="https://hyundaicolombia.co/terminos-condiciones"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terminos y condiciones
          </a>
        </div>

        <div
          className={`send ${isValid() && !isLogin ? "active" : ""}`}
          onClick={handleSubmit}
        >
          Enviar mensaje
          {isValid() && isLogin ? (
            <span
              className="spinner-border spinner-border-sm ms-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : null}
        </div>
      </div>

      <div className="right">
        {/* H2 - Título de la sección derecha */}
        <h2 className="title">Queremos escucharte</h2>

        {/* H3 - Subtítulos de información de contacto */}
        <h3 className="subtitle">Envíanos un correo</h3>
        <div className="txt">scliente.hyundai.co@astara.com</div>

        <h3 className="subtitle">Llámanos</h3>
        <div className="txt">Línea de servicio al cliente 01 8000 931 030</div>

        {/* BOTÓN SIN MODIFICAR */}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={"https://wa.me/5715190055?text=Hyundai"}
          className="chatea"
        >
          Contáctanos por WhatsApp
        </a>
      </div>
    </div>
  );
};

export default ContenidoComponent;
